import React, { createContext, useContext, useMemo } from 'react';
export const defaultSpacingFunc = space => space;
export const SpacingFuncContext = /*#__PURE__*/createContext(defaultSpacingFunc);
export const useSpacingFunc = () => useContext(SpacingFuncContext);
export const useSpacing = size => {
  const spacingFunc = useSpacingFunc();
  return useMemo(() => spacingFunc(size), [spacingFunc, size]);
};
export const SpacingFuncProvider = _ref => {
  let {
    children,
    spacingFunc = defaultSpacingFunc
  } = _ref;
  return /*#__PURE__*/React.createElement(SpacingFuncContext.Provider, {
    value: spacingFunc
  }, children);
};
//# sourceMappingURL=SpacingFuncContext.js.map